import { redirectToMarketplaceLogin } from "../auth/sessionExpiry";

let refreshIntervalId = null;
let visibilityHandler = null;

/**
 * Starts periodic token refresh and listens for tab focus to refresh immediately.
 * Safe to call multiple times — cleans up previous listeners before re-registering.
 */
export function startTokenRefresh(keycloak) {
  // Always clean up first so re-login works and intervals don't stack
  stopTokenRefresh();

  if (!keycloak.tokenParsed) return;

  // Periodic refresh: every 30s, refresh if token expires within 60s
  refreshIntervalId = setInterval(() => {
    keycloak
      .updateToken(60)
      .then(() => {})
      .catch(() => {
        redirectToMarketplaceLogin();
      });
  }, 30000);

  // Refresh immediately when the browser tab regains focus.
  // Browsers throttle setInterval in background tabs, so the periodic
  // refresh may not run while the tab is hidden. This ensures the token
  // is fresh before React Query refetches on window focus.
  visibilityHandler = () => {
    if (document.visibilityState === "visible") {
      keycloak
        .updateToken(60)
        .then(() => {})
        .catch(() => {
          redirectToMarketplaceLogin();
        });
    }
  };
  document.addEventListener("visibilitychange", visibilityHandler);
}

/**
 * Stops the periodic token refresh and removes the visibility listener.
 * Called on logout or before re-starting the refresh cycle.
 */
export function stopTokenRefresh() {
  if (refreshIntervalId) {
    clearInterval(refreshIntervalId);
    refreshIntervalId = null;
  }
  if (visibilityHandler) {
    document.removeEventListener("visibilitychange", visibilityHandler);
    visibilityHandler = null;
  }
}
